import React from 'react'
import { Carousel } from 'react-bootstrap'

const Banner = ({end}) => {
    console.log("end part",end);
    return (
    <>
      <Carousel fade>
          {end.map((item,index)=>{
              return(
                <Carousel.Item interval={1000} key={item.image}>
                <img
                  className="d-block w-100"
                  id="Banner imageS"
                  src={item.image}
                  alt={`${index} banner`}
                />
                <Carousel.Caption>
                  <h3>{item.name}</h3>
                  <p>{item['description']}</p>
                  <p>{item['source']}</p>
                  <u>Read More</u>
                </Carousel.Caption>
              </Carousel.Item>
              )
          })
          
          }
      </Carousel>      
    </>
    )
}

export default Banner
